import { render, staticRenderFns } from "./mianyibiaoxing.vue?vue&type=template&id=1d08b396&scoped=true&"
import script from "./mianyibiaoxing.vue?vue&type=script&lang=js&"
export * from "./mianyibiaoxing.vue?vue&type=script&lang=js&"
import style0 from "./mianyibiaoxing.vue?vue&type=style&index=0&id=1d08b396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d08b396",
  null
  
)

export default component.exports